(function(document, window, $) {
    'use strict';

    window.AppCalendar = App.extend({
        handleFullcalendar: function() {

            var my_options = {
                header: {
                    left: 'today',
                    center: 'prev,title,next',
                    right: 'month,agendaWeek,agendaDay'
                },
                firstDay: 1,

                agendaEventMinHeight: 20,

                selectable: true,
                selectHelper: true,
                select: function(start, end, allDay) {
                    // console.log('here');
                    // console.log(start.format());
                    // console.log(end.format());
                },
                editable: true,
                eventLimit: false,
                height:"auto",
                windowResize: function(view) {
                    var width = $(window).outerWidth();
                    var options = $.extend({}, my_options);
                    var aspectRatio = width < 667 ? 0.5 : 1.35;

                 //   $('#calendar').fullCalendar('option', 'aspectRatio', aspectRatio);
                },
                eventDrop: function(event, delta, revertFunc) {
                   AppCalendar.updateCalendar(event, delta, 'start');
                },

                eventResize: function(event, delta, revertFunc) {
                    AppCalendar.updateCalendar(event, delta, 'end');
                },

                dayClick: function(date, jsEvent, view) {
                   // console.log(view.name);
                    if (view.name === "month") {
                        $('#calendar').fullCalendar('gotoDate', date);
                        $('#calendar').fullCalendar('changeView', 'agendaDay');
                    }
                },

                eventClick: function(event) {

                   // console.log(event);
                    $.slidePanel.show({
                        url: event.ajaxurl,
                        settings: {
                            cache: false
                        }
                    }, window.PanelOptions);

                },
                eventDragStart: function() {

                   // $.site.actionBtn.expand();
                },
                eventDragStop: function() {
                   // $.site.actionBtn.shrink();
                },
                //events: my_events,

                events: {
                    url: $('#calendar').attr('data-feed'),
                    cache: false,
                    data: function(){
                       // var o = {};

                        var o = $('#calendar-filter').serializeArray();


                        return o;
                    }
                },
                droppable: true
            };

            var _options;
            var my_options_mobile = $.extend({}, my_options);

            my_options_mobile.aspectRatio = 0.5;
            _options = $(window).outerWidth() < 667 ? my_options_mobile : my_options;

          //  $('#editNewEvent').modal();
            $('#calendar').fullCalendar(_options);
        },


        updateCalendar: function (event, delta, type){
            var updateUrl = $('#calendar').attr('data-update');
            $.ajax({
                url: updateUrl,
                type: "POST",
                dataType: "json",
                data: ({
                    id: event.id,
                    daydelta: delta.days(),
                    hourdelta: delta.hours(),
                    type: type

                }),
                success: function(data) {
                    if (!data)
                    {
                        return;
                    }

                    if(data.status == false){
                        alertify.alert(data['error']);
                    }
                },
                error: function() {
                    alertify.alert("There was a problem saving the events. Try again later");
                }
            });
        },
        handleAction: function() {
           // var actionBtn = $('.site-action').actionBtn().data('actionBtn');
        },

        handleEventList: function() {
            //$('#addNewEventBtn').on('click', function() {
            //    $('#addNewEvent').modal('show');
            //});

            $('.calendar-list .calendar-event').each(function() {
                var $this = $(this),
                    color = $this.data('color').split('-');
                $this.data('event', {
                    title: $this.data('title'),
                    stick: $this.data('stick'),
                    backgroundColor: $.colors(color[0], color[1]),
                    borderColor: $.colors(color[0], color[1])
                });
                $this.draggable({
                    zIndex: 999,
                    revert: true,
                    revertDuration: 0,
                    helper: function() {
                        return '<a class="fc-day-grid-event fc-event fc-start fc-end" style="background-color:' + $.colors(color[0], color[1]) + ';border-color:' + $.colors(color[0], color[1]) + '">' +
                            '<div class="fc-content">' +
                            '<span class="fc-title">' + $this.data('title') + '</span>' +
                            '</div>' +
                            '</a>';
                    }
                });
            });
        },

        refreshCalendar: function() {
                $('#calendar').fullCalendar( 'refetchEvents' );
        },

        handleListenForEvents: function() {
            var that = this;
            $('body').on('activity:added', function( event ){
               that.refreshCalendar();
            });

            $('#calendar-filter select').on('change', function(event){
                that.refreshCalendar();
            })
        },

        run: function(next) {

            var calendar = $('#calendar');

            if (!calendar.length) { next(); return;}

            //$('#addNewCalendarForm').modal({
            //    show: false
            //});

           // console.log('here');
            //this.handleEventList();
            this.handleFullcalendar();
            this.handleListenForEvents();
            //this.handleAction();

            next();
        }
    });

    $(document).ready(function() {
        AppCalendar.run();
    });
})(document, window, jQuery);
